import {MailTemplate} from '@common/admin/settings/pages/email-settings/templates/mail-template';
import {get} from '@common/http/queries-file-helpers';
import {queryOptions} from '@tanstack/react-query';

export const mailTemplateQueries = {
  invalidateKey: ['mail-templates'],
  index: () =>
    queryOptions({
      queryKey: ['mail-templates'],
      queryFn: () => get<{templates: MailTemplate[]}>('mail-templates'),
    }),
  get: (key: string) =>
    queryOptions({
      queryKey: ['mail-templates', key],
      queryFn: () => get<{template: MailTemplate}>(`mail-templates/${key}`),
    }),
};
